module.exports = __webpack_public_path__ + "img/eicon3.fdd03b46.png";